import { Injectable } from '@angular/core';
import { licenseKey } from '../../../devextreme-license';

@Injectable({
  providedIn: 'root'
})
export class DevExtremeConfigService {
  private isConfigured = false;
  private configPromise: Promise<void> | null = null;

  configureDevExtreme(): void {
    if (this.isConfigured) return;
    if (!this.configPromise) {
      this.configPromise = import('devextreme/core/config').then((configModule) => {
        const config = configModule.default;
        config({ licenseKey });
        this.isConfigured = true;
        console.log('DevExtreme configured successfully');
      });
    }
    // Fire-and-forget; callers can await getConfigPromise() if they need to wait
    void this.configPromise;
  }

  /** Await this before using DevExtreme if you need config to be applied first. */
  getConfigPromise(): Promise<void> {
    this.configureDevExtreme();
    return this.configPromise ?? Promise.resolve();
  }

  isDevExtremeConfigured(): boolean {
    return this.isConfigured;
  }
}
